import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sub_page_con wrap_1120 mypage_apply" }
const _hoisted_2 = { class: "search_wrap" }
const _hoisted_3 = {
  key: 0,
  class: "btn_wrap _default float_right _board_type"
}
const _hoisted_4 = { class: "list_table con_board sub_page_con_view myContent" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "thead_li" }
const _hoisted_7 = { class: "tr_div con_tit" }
const _hoisted_8 = { class: "tb_chk checkbox_wrap" }
const _hoisted_9 = { for: "all" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["for"]
const _hoisted_12 = ["id", "value", "disabled"]
const _hoisted_13 = { class: "tb_no D_only" }
const _hoisted_14 = { class: "tb_board" }
const _hoisted_15 = {
  class: "tb_subject",
  style: {"display":"inline-flex"}
}
const _hoisted_16 = ["textContent"]
const _hoisted_17 = {
  key: 0,
  class: "tb_part"
}
const _hoisted_18 = {
  key: 0,
  class: "tb_part"
}
const _hoisted_19 = {
  key: 1,
  class: "tb_part"
}
const _hoisted_20 = {
  key: 2,
  class: "tb_part"
}
const _hoisted_21 = {
  key: 3,
  class: "tb_part"
}
const _hoisted_22 = { class: "tb_date_hour" }
const _hoisted_23 = { class: "_flex _cate small_txt" }
const _hoisted_24 = { class: "tb_board" }
const _hoisted_25 = {
  key: 0,
  class: "tb_part"
}
const _hoisted_26 = {
  key: 0,
  class: "tb_part"
}
const _hoisted_27 = {
  key: 1,
  class: "tb_part"
}
const _hoisted_28 = {
  key: 2,
  class: "tb_part"
}
const _hoisted_29 = {
  key: 3,
  class: "tb_part"
}
const _hoisted_30 = { class: "_flex _flex_100 _jc_sb" }
const _hoisted_31 = {
  class: "tb_subject",
  style: {"display":"inline-flex"}
}
const _hoisted_32 = ["textContent"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "m_option_wrap" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "tb_date_hour" }
const _hoisted_37 = {
  key: 1,
  class: "tbody_li no_data"
}
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "thead_li" }
const _hoisted_40 = { class: "tr_div con_tit" }
const _hoisted_41 = { class: "tb_chk checkbox_wrap" }
const _hoisted_42 = { for: "all" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["for"]
const _hoisted_45 = ["id", "value"]
const _hoisted_46 = { class: "tb_no D_only" }
const _hoisted_47 = { class: "tb_board" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = {
  key: 1,
  class: "_flex _cate"
}
const _hoisted_52 = ["for"]
const _hoisted_53 = ["id", "value"]
const _hoisted_54 = {
  key: 0,
  class: "tb_board"
}
const _hoisted_55 = {
  key: 1,
  class: "tb_board"
}
const _hoisted_56 = {
  key: 2,
  class: "tb_board"
}
const _hoisted_57 = {
  class: "tb_subject",
  style: {"display":"inline-flex"}
}
const _hoisted_58 = { class: "tb_condition D_only" }
const _hoisted_59 = { class: "tb_date_hour _cate" }
const _hoisted_60 = {
  key: 1,
  class: "tbody_li no_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.searchText) = $event)),
        onKeyup: [
          _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)), ["enter"])),
          _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)))
        ],
        placeholder: "검색어를 입력하세요."
      }, null, 544), [
        [_vModelText, $setup.state.searchText]
      ]),
      _createElementVNode("button", {
        class: "search_btn icon_wrap",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)))
      }, [...(_cache[22] || (_cache[22] = [
        _createElementVNode("img", {
          src: "img/search_btn.png",
          alt: ""
        }, null, -1)
      ]))])
    ]),
    (!$setup.state.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "common_btn _gray",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
          }, "삭제")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "checkbox_wrap",
      style: _normalizeStyle(!$setup.state.isMobile ? 'margin-top: 20px' : 'margin-top:10px; margin-bottom: 10px')
    }, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "report",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.selectedType) = $event)),
          onChange: _cache[6] || (_cache[6] = ($event: any) => {
                        $setup.getReportList();
                        $setup.state.checkedList = [];
                    })
        }, null, 544), [
          [_vModelRadio, $setup.state.selectedType]
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("em", null, null, -1)),
        _cache[24] || (_cache[24] = _createElementVNode("span", null, "시민제보", -1))
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "participate",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.selectedType) = $event)),
          onChange: _cache[8] || (_cache[8] = ($event: any) => {
                        $setup.getReportList();
                        $setup.state.checkedList = [];
                    })
        }, null, 544), [
          [_vModelRadio, $setup.state.selectedType]
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("em", null, null, -1)),
        _cache[26] || (_cache[26] = _createElementVNode("span", null, "시민참여", -1))
      ])
    ], 4),
    _createElementVNode("div", _hoisted_4, [
      ($setup.state.selectedType === 'report')
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      id: "all",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.checkAll) = $event)),
                      onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.toggleAll()))
                    }, null, 544), [
                      [_vModelCheckbox, $setup.state.checkAll]
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("em", null, null, -1))
                  ])
                ]),
                _cache[28] || (_cache[28] = _createStaticVNode("<div class=\"tb_no D_only\" data-v-551e736c>번호</div><div class=\"tb_board\" data-v-551e736c>게시판</div><div class=\"tb_subject\" data-v-551e736c>제목</div><div class=\"tb_part\" data-v-551e736c>분류</div><div class=\"tb_date_hour\" data-v-551e736c>날짜</div>", 5))
              ])
            ]),
            ($setup.state.list.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "tbody_li",
                    key: item.idx
                  }, [
                    _createElementVNode("div", {
                      class: "tr_div con_tit",
                      onClick: ($event: any) => ($setup.toggle(index))
                    }, [
                      (!$setup.state.isMobile)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", {
                              class: "tb_chk checkbox_wrap",
                              onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _withDirectives(_createElementVNode("label", {
                                for: item.idx + ''
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.state.checkedList) = $event)),
                                  id: item.idx + '',
                                  value: item.idx,
                                  onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                                  disabled: item.state !== 1
                                }, null, 8, _hoisted_12), [
                                  [_vModelCheckbox, $setup.state.checkedList]
                                ]),
                                _cache[29] || (_cache[29] = _createElementVNode("em", null, null, -1))
                              ], 8, _hoisted_11), [
                                [_vShow, item.state !== 2]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (index + 1)), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.type === 1 ? "의심 업소" : "알선 광고"), 1),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_router_link, {
                                to: { name: 'AdView', params: { id: item.idx } },
                                class: "elips_1",
                                style: {"width":"auto !important"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("u", null, _toDisplayString((item as types.ResReportVOForApi).title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("span", {
                                class: _normalizeClass([item.state === 1 ? 'ans_yet' : 'ans_complete']),
                                textContent: _toDisplayString(item.state === 1 ? '접수중' : '접수완료')
                              }, null, 10, _hoisted_16)
                            ]),
                            (item.type === 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString((item as types.ResReportVOForApi).isSchool === 1 ? "학교주변" : "의심업소"), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  ((item as types.ResReportVOForApi).adType === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, "온라인 알선 광고"))
                                    : ((item as types.ResReportVOForApi).adType === 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, "지면 광고"))
                                      : ((item as types.ResReportVOForApi).adType === 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, "불법옥외광고물"))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_21, "기타"))
                                ], 64)),
                            _createElementVNode("div", _hoisted_22, [
                              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "mo_th" }, "날짜", -1)),
                              _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, _toDisplayString(item.type === 1 ? "의심 업소" : "알선 광고"), 1),
                              _cache[31] || (_cache[31] = _createElementVNode("span", { class: "divider" }, "｜", -1)),
                              (item.type === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString((item as types.ResReportVOForApi).isSchool === 1 ? "학교주변" : "의심업소"), 1))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    ((item as types.ResReportVOForApi).adType === 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, "온라인 알선 광고"))
                                      : ((item as types.ResReportVOForApi).adType === 2)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "지면 광고"))
                                        : ((item as types.ResReportVOForApi).adType === 3)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, "불법옥외광고물"))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_29, "기타"))
                                  ], 64))
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'AdView', params: { id: item.idx } },
                                  class: "elips_1",
                                  style: {"width":"auto !important"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("u", null, _toDisplayString((item as types.ResReportVOForApi).shopName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createElementVNode("span", {
                                  class: _normalizeClass([item.state === 1 ? 'ans_yet' : 'ans_complete']),
                                  textContent: _toDisplayString(item.state === 1 ? '접수중' : '접수완료')
                                }, null, 10, _hoisted_32),
                                (item.state === 1)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "m_option_btn icon_wrap only_768",
                                      onClick: ($event: any) => ($setup.optionOpen(item))
                                    }, [...(_cache[32] || (_cache[32] = [
                                      _createElementVNode("img", {
                                        src: "img/kebabIcon.png",
                                        class: ""
                                      }, null, -1)
                                    ]))], 8, _hoisted_33))
                                  : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "_gray",
                                    onClick: ($event: any) => ($setup.optionClose(item))
                                  }, "삭제", 8, _hoisted_35)
                                ], 512), [
                                  [_vShow, $setup.state.isShowBtn && $setup.state.list_idx === item.idx]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_36, _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                            ])
                          ], 64))
                    ], 8, _hoisted_10)
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("li", _hoisted_37, [...(_cache[33] || (_cache[33] = [
                  _createElementVNode("div", { class: "tr_div" }, [
                    _createElementVNode("div", {
                      class: "tb_subject",
                      style: {"text-align":"center","width":"100%"}
                    }, "등록된 게시물이 없습니다.")
                  ], -1)
                ]))]))
          ]))
        : ($setup.state.selectedType === 'participate')
          ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [
              _createElementVNode("li", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.state.checkAll) = $event)),
                        onChange: _cache[15] || (_cache[15] = ($event: any) => ($setup.toggleAll())),
                        id: "all"
                      }, null, 544), [
                        [_vModelCheckbox, $setup.state.checkAll]
                      ]),
                      _cache[34] || (_cache[34] = _createElementVNode("em", null, null, -1))
                    ])
                  ]),
                  _cache[35] || (_cache[35] = _createStaticVNode("<div class=\"tb_no D_only\" data-v-551e736c>번호</div><div class=\"tb_board\" data-v-551e736c>게시판</div><div class=\"tb_subject\" data-v-551e736c>제목</div><div class=\"tb_condition\" data-v-551e736c>조회수</div><div class=\"tb_date_hour\" data-v-551e736c>날짜</div>", 5))
                ])
              ]),
              ($setup.state.list.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "tbody_li",
                      key: item.idx
                    }, [
                      _createElementVNode("div", {
                        class: "tr_div con_tit",
                        onClick: ($event: any) => ($setup.toggle(index))
                      }, [
                        (!$setup.state.isMobile)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", {
                                class: "tb_chk checkbox_wrap",
                                onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("label", {
                                  for: item.idx + ''
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.state.checkedList) = $event)),
                                    id: item.idx + '',
                                    value: item.idx,
                                    onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 8, _hoisted_45), [
                                    [_vModelCheckbox, $setup.state.checkedList]
                                  ]),
                                  _cache[36] || (_cache[36] = _createElementVNode("em", null, null, -1))
                                ], 8, _hoisted_44)
                              ]),
                              _createElementVNode("div", _hoisted_46, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (index + 1)), 1),
                              _createElementVNode("div", _hoisted_47, [
                                (item.type === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "반성매매 시민활동"))
                                  : (item.type === 2)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, "캠페인·이벤트"))
                                    : (item.type === 3)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, "반성매매 활동 제안"))
                                      : _createCommentVNode("", true)
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createElementVNode("div", {
                                class: "tb_chk checkbox_wrap",
                                onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("label", {
                                  for: item.idx + ''
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.state.checkedList) = $event)),
                                    id: item.idx + '',
                                    value: item.idx,
                                    onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 8, _hoisted_53), [
                                    [_vModelCheckbox, $setup.state.checkedList]
                                  ]),
                                  _cache[37] || (_cache[37] = _createElementVNode("em", null, null, -1))
                                ], 8, _hoisted_52)
                              ]),
                              _cache[38] || (_cache[38] = _createElementVNode("span", { class: "mo_th" }, "게시판", -1)),
                              (item.type === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, "반성매매 시민활동"))
                                : (item.type === 2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, "캠페인·이벤트"))
                                  : (item.type === 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, "반성매매 활동 제안"))
                                    : _createCommentVNode("", true)
                            ])),
                        _createElementVNode("div", _hoisted_57, [
                          _createVNode(_component_router_link, {
                            to: { name: 'SuggestView', params: { id: item.idx } },
                            class: "elips_1",
                            style: {"width":"auto !important"}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("u", null, _toDisplayString((item as types.ResBoardVOForApi).title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "mo_th" }, "조회수", -1)),
                          _createTextVNode(" " + _toDisplayString((item as types.ResBoardVOForApi).viewCnt), 1)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "mo_th" }, "날짜", -1)),
                          _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                        ])
                      ], 8, _hoisted_43)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("li", _hoisted_60, [...(_cache[41] || (_cache[41] = [
                    _createElementVNode("div", { class: "tr_div" }, [
                      _createElementVNode("div", {
                        class: "tb_subject",
                        style: {"text-align":"center","width":"100%"}
                      }, "등록된 게시물이 없습니다.")
                    ], -1)
                  ]))]))
            ]))
          : _createCommentVNode("", true)
    ]),
    ($setup.state.list.length !== 0)
      ? (_openBlock(), _createBlock(_component_PageBtn, {
          key: 1,
          currentPage: $setup.state.page,
          totalLength: $setup.state.totalLength,
          perPage: $setup.state.size,
          onOnPaging: $setup.handlePageChange
        }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 2,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ]))
}